import { ReactiveControllerHost, ReactiveController } from 'lit';
import { debounce } from '../utilities/debounce';
// @todo: Figure out why outline-config isn't working.
// import { defaultScreenSizes } from '@phase2/outline-config';
const defaultScreenSizes = {
  xs: '480px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1440px',
  xxxl: '2160px',
};

//TODO: add functionality to receive array of screen sizes to map to object in controller state
export class MobileController implements ReactiveController {
  isMobile = false;
  host: ReactiveControllerHost;
  mobileBreakpoint: string;

  constructor(host: ReactiveControllerHost, mobileBreakpoint = 'md') {
    this.mobileBreakpoint = mobileBreakpoint;
    (this.host = host).addController(this);
    this.handleResize();
  }

  hostConnected() {
    window.addEventListener(
      'resize',
      debounce(() => {
        this.handleResize();
      }, 0)
    );
  }

  hostDisconnected() {
    window.removeEventListener(
      'resize',
      debounce(() => {
        this.handleResize();
      }, 0)
    );
  }

  handleResize = () => {
    const mobileScreen = this.formatScreenSize(
      //@ts-expect-error because ts
      defaultScreenSizes[this.mobileBreakpoint]
    );
    if (window.innerWidth < mobileScreen) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.host.requestUpdate();
  };

  formatScreenSize = (screen: string): number => {
    return parseInt(screen.slice(0, -2));
  };
}
